import ActiveController from "rapid/controller";
import _ from "lodash";

export class formPreviewController extends ActiveController {
    constructor($injector, $rootScope, $element, $scope) {
        "ngInject";
        super($injector);

        this.$rootScope = $rootScope;
        this.$element = angular.element($element);
        this.$scope = $scope;
        this.definedFields = [];
        this.customFields = [];
    }

    $onInit() {
        this.$scope.$watch(() => this.definedInputs, () => {
            const inputs = _.cloneDeep(this.definedInputs);

            if (inputs) {
                this.definedFields = inputs.map((input, i) => {
                    switch (i) {
                        case 0 :
                            input.placeholder = ["Max", "Mustermann"];
                            input.title = ["First Name", "Last Name"];
                            break;
                        case 1 :
                            input.placeholder = "email@box.com";
                            input.title = "Email";
                            break;
                        case 2 :
                            input.placeholder = "0123456789";
                            input.title = "Phone";
                            break;
                    }
                    return input;
                });
            }
        }, true);

        this.$scope.$watch(() => this.customInputs, () => {
            const inputs = _.cloneDeep(this.customInputs);

            if (inputs && inputs.length) {
                this.customFields = inputs.map(input => ({
                    ...input,
                    title: input.title,
                    placeholder: "Please enter"
                }));
            }
        }, true);
        this.$scope.$watch(() => this.checkboxes, () => {
        });
    }
}



// WEBPACK FOOTER //
// ./sources/components/common/forms-preview/form-preview.controller.js